import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import type { ResolvedToolCall } from "../../../../model/block.types";

/**
 * Debug-only inline chip showing a single tool call dispatched by the LLM.
 * Displays a spinner while the result is pending and a checkmark once received.
 * Visibility is controlled by the parent (shown only in debug mode).
 */
@Component({
  selector: "app-tool-call-hint",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  templateUrl: "./tool-call-hint.component.html",
  styleUrl: "./tool-call-hint.component.scss",
})
export class ToolCallHintComponent {
  readonly toolCall = input.required<ResolvedToolCall>();
}
